import React from 'react';
import { TrainingGoalSection } from '@/components/training-goals/TrainingGoalSection';
import { useUserProfile } from '@/hooks/useUserProfile';

const MonthlyProgressSection: React.FC = () => {
  const { profile } = useUserProfile();

  // Hide Goal section for instructors
  if (profile?.is_instructor) {
    return null;
  }

  return (
    <section className="mb-8">
      <TrainingGoalSection />
    </section>
  );
};

export default MonthlyProgressSection;
